import {
  FlagUpdatesSchemaDetails,
  createFlagUpdatesChangeExtension,
} from '@spotify/plugin-confidence-flags-react';

export const SCHEMA_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'schema-change',
  predicate: ({ change }) =>
    change.fieldType ===
    'confidence.flags.types.v1.FlagSchema.StructFlagSchema',
  render: ({ change }) => (
    <FlagUpdatesSchemaDetails
      oldSchema={change.oldValue}
      newSchema={change.newValue}
    />
  ),
});
